const setErrorMessage = async (message) => {

    document.getElementById("errordiv").innerText = message;

    setTimeout(function () {
        const errordiv = document.getElementById("errordiv")
        if (errordiv !== null) {
            errordiv.innerText = "";
        }
    }, 10000);
}

const settopMessage = async (message) => {
    document.getElementById("messagetopdiv").innerText = message;
    setTimeout(function () {
        const messagediv = document.getElementById("messagetopdiv")
        if (messagediv !== null) {
            messagediv.innerText = "";
        }
    }, 10000);
}

const cleartopMessage = async () => {
    document.getElementById("messagetopdiv").innerText = "";

}
const setMessage = async (message) => {
    if(message === null || message === undefined)
        message = "Even geduld aub." 
    if( document.getElementById("messagetext").innerHTML !== message)
        document.getElementById("messagetext").innerHTML = message;

    if( document.getElementById("coverAllmessage") != null)
        document.getElementById("coverAllmessage").style.display = "block";
    document.getElementById("messagetext").style.display = "block";
    document.getElementById("messagediv").style.display = "block";
}
const setHTMLMessage = async (message) => {
    document.getElementById("messagetext").innerHTML = message;
    document.getElementById("messagetext").style.display = "block";
    if( document.getElementById("coverAllmessage") != null)
        document.getElementById("coverAllmessage").style.display = "block";
    document.getElementById("messagediv").style.display = "block";
}
const clearMessage = () => {
    document.getElementById("messagetext").innerText = "";
    if( document.getElementById("coverAllmessage") != null)
        document.getElementById("coverAllmessage").style.display = "none";
    document.getElementById("messagediv").style.display = "none";
    document.getElementById("messagetext").style.display = "none";
}

export { setErrorMessage, setMessage, clearMessage,setHTMLMessage,settopMessage,cleartopMessage }